// extracted by mini-css-extract-plugin
export default {"wrapper":"entry-pilih-listing_wrapper__eOiZo","box":"entry-pilih-listing_box__kqYGj","golden":"entry-pilih-listing_golden__kEGUV"};